export default __webpack_public_path__ + "static/media/logo-text.5b7a9635.svg";